interface PropsType {
  style?: React.CSSProperties;
  color?: string;
}

const DocumentIcon = (props: PropsType) => {
  return (
    <svg width="27" height="32" viewBox="0 0 27 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M21.4339 0H10.4083H9.55445L8.95049 0.581312L0.6028 8.63138L0 9.21319V10.0366V26.6313C0 29.5911 2.4974 32 5.5672 32H21.434C24.5026 32 27 29.5911 27 26.6313V5.36763C26.9999 2.40775 24.5026 0 21.4339 0ZM24.9388 26.6313C24.9388 28.4984 23.3696 30.0123 21.434 30.0123H5.5672C3.63099 30.0123 2.06122 28.4984 2.06122 26.6313V10.0367H7.48707C9.09968 10.0367 10.4083 8.77525 10.4083 7.21956V1.98763H21.434C23.3696 1.98763 24.9388 3.5015 24.9388 5.36756V26.6313Z"
        fill={props.color ? props.color : 'white'}
      />
      <path
        d="M19.12 9.96411C18.6231 10.2995 18.018 10.4977 17.3668 10.4977C16.715 10.4977 16.1105 10.2995 15.6129 9.96411C14.7433 10.325 14.2092 10.958 13.8833 11.517C13.4504 12.2585 13.7898 13.3082 14.5374 13.3082C15.2859 13.3082 17.3668 13.3082 17.3668 13.3082C17.3668 13.3082 19.447 13.3082 20.1957 13.3082C20.9437 13.3082 21.2836 12.2585 20.8503 11.517C20.5243 10.9579 19.9902 10.325 19.12 9.96411Z"
        fill={props.color ? props.color : 'white'}
      />
      <path
        d="M17.3666 9.79513C18.6448 9.79513 19.6799 8.79694 19.6799 7.56482V7.03019C19.6799 5.79919 18.6448 4.79932 17.3666 4.79932C16.0889 4.79932 15.0527 5.79919 15.0527 7.03019V7.56482C15.0527 8.79694 16.089 9.79513 17.3666 9.79513Z"
        fill={props.color ? props.color : 'white'}
      />
      <path d="M20.8899 16.2732H5.95801V17.6714H20.8899V16.2732Z" fill={props.color ? props.color : 'white'} />
      <path d="M20.8899 20.468H5.95801V21.8668H20.8899V20.468Z" fill={props.color ? props.color : 'white'} />
      <path d="M16.4107 24.6628H5.95801V26.0605H16.4107V24.6628Z" fill={props.color ? props.color : 'white'} />
    </svg>
  );
};

export default DocumentIcon;
